export enum NotificationSourceEnum {
  pqrsd = 1,
  process = 2,
}
